import { MiddlewareFunction, redirect } from 'react-router';

import { fetchCurrentUser } from '@/contexts/userContext/util/fetchCurrentUser.util.ts';
import { RouteEnum } from '@/models/route/Route.model.ts';
import { getRouteAccess, hasRouteAccess } from '@/models/route/routeAccess.util.ts';

export const assertRouteAccess = async (path: RouteEnum): Promise<void> => {
  const routeAccess = getRouteAccess(path);

  if (routeAccess.rolesWithAccess.length === 0 && routeAccess.permissionsWithAccess.length === 0) {
    return;
  }

  const user = await fetchCurrentUser().catch(() => null);
  // no user / role / enabled flag → let it through; UserContextProvider
  // renders an error or approval screen instead of the route
  if (!user?.role || !user.enabled) {
    return;
  }

  if (!hasRouteAccess(routeAccess, user)) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- react-router expects a thrown Response for redirects
    throw redirect(RouteEnum.FORBIDDEN);
  }
};

export const contextMiddleware =
  (path: RouteEnum): MiddlewareFunction =>
  async (_args, next) => {
    await assertRouteAccess(path);
    return next();
  };
